import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Button } from '@mui/material';
import { useState, useCallback } from 'react';

interface HoldTicketDialogProps {
  open: boolean;
  onClose: () => void;
  onHold: (comments: string) => Promise<void>;
  isHolding: boolean;
}

export function HoldTicketDialog({ open, onClose, onHold, isHolding }: HoldTicketDialogProps) {
  const [comments, setComments] = useState('');
  
  const handleSubmit = useCallback(async () => {
    await onHold(comments);
    setComments('');
  }, [comments, onHold]);
  
  const handleClose = useCallback(() => {
    setComments('');
    onClose();
  }, [onClose]);
  
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Place Ticket On Hold</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please provide a reason for placing this ticket on hold.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="comments"
          label="Hold Comments"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          color="warning" 
          disabled={isHolding}
        >
          {isHolding ? 'Placing on Hold...' : 'Confirm Hold'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
